import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getAsset } from 'modules/assets';
import { TalentCardHeader } from 'modules/sharing';

function ClientCard({ talent }) {
  const navigate = useNavigate();
  const { profileImage } = talent;
  const [profileUrl, setProfileUrl] = useState(null);

  useEffect(() => {
    if (profileImage) {
      getAsset(profileImage)
        .then(url => setProfileUrl(url))
        .catch(err => console.log(err));
    }
  }, [profileImage, setProfileUrl]);

  function handleClick() {
    const talentPath = `/talent/${talent.id}`;
    navigate(talentPath);
  }

  return (
    <TalentCardHeader
      onClick={handleClick}
      talent={talent}
      avatar={profileUrl}
      showOnlyHeader
    />
  );
}

ClientCard.propTypes = {
  talent: PropTypes.object.isRequired,
};

export default ClientCard;
